import { ChangeEvent } from 'react';

import {
   SharedGridTableCell,
   SharedGridTableRow,
   TextInputWithChangedState,
} from 'components/shared';
import { usePalletsTypes } from 'constants/palletTypes';
import { PalletsPricingPerAddressFormDataItem, PalletType } from 'interfaces';

import styles from './PalletsPricingPerAddressInnerFormTableRow.module.css';

export type PalletsPricingPerAddressInnerFormTableRowProps = {
   isBasePalletsPricingRows: boolean;
   fullAddress: string;
   palletPricing: PalletsPricingPerAddressFormDataItem;
   basePalletPricing: PalletsPricingPerAddressFormDataItem;
   error?: Record<string, boolean>;
   onPalletPricingChange: (
      isBasePalletsPricing: boolean,
      enteredValue: string,
      palletType: PalletType,
      address: string,
   ) => void;
   onPalletPricingBlur: (
      isBasePalletsPricing: boolean,
      enteredValue: string,
      palletType: PalletType,
      address: string,
   ) => void;
};

const PalletsPricingPerAddressInnerFormTableRow = ({
   isBasePalletsPricingRows,
   fullAddress,
   palletPricing,
   basePalletPricing,
   error,
   onPalletPricingChange,
   onPalletPricingBlur,
}: PalletsPricingPerAddressInnerFormTableRowProps) => {
   const { palletType, deliveryPrice } = palletPricing;
   const { deliveryPrice: baseDeliveryPrice } = basePalletPricing;

   const { PALLET_TYPES_LABELS_WITH_DIMENSIONS } = usePalletsTypes();

   const handlePalletsPricingChange = (event: ChangeEvent<HTMLInputElement>) => {
      const enteredValue = event.target.value;
      onPalletPricingChange(isBasePalletsPricingRows, enteredValue, palletType, fullAddress);
   };

   const handlePalletsPricingBlur = (event: ChangeEvent<HTMLInputElement>) => {
      const enteredValue = event.target.value;
      onPalletPricingBlur(isBasePalletsPricingRows, enteredValue, palletType, fullAddress);
   };

   const isBaseDeliveryPriceDifferent = deliveryPrice !== baseDeliveryPrice;

   return (
      <SharedGridTableRow className={styles.row}>
         <SharedGridTableCell className={styles.cell}>
            <h3>{PALLET_TYPES_LABELS_WITH_DIMENSIONS[palletType].label}</h3>
            <p>{PALLET_TYPES_LABELS_WITH_DIMENSIONS[palletType].dimensions}</p>
         </SharedGridTableCell>
         <SharedGridTableCell className={styles.cell}>
            <TextInputWithChangedState
               value={deliveryPrice}
               name="deliveryPrice"
               type="text"
               isValueChanged={isBaseDeliveryPriceDifferent}
               fullWidth
               iconPosition="right"
               onChange={handlePalletsPricingChange}
               onBlur={handlePalletsPricingBlur}
               error={error?.deliveryPrice}
            />
         </SharedGridTableCell>
      </SharedGridTableRow>
   );
};

export default PalletsPricingPerAddressInnerFormTableRow;
